'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _client = require('../client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserList = function (_React$Component) {
  _inherits(UserList, _React$Component);

  function UserList(props) {
    _classCallCheck(this, UserList);

    var _this = _possibleConstructorReturn(this, (UserList.__proto__ || Object.getPrototypeOf(UserList)).call(this));

    console.log("USER");
    _this.state = {
      data: []
    };
    _client2.default.service('users').find({
      query: {
        '$sort': { 'email': '1' },
        token: _client2.default.get('token')
      }
    }).then(function (data) {
      _this.setState(data);
    }).catch(function (error) {
      console.error(error);
    });
    _this.pick.bind(_this);
    _this.handleDelete.bind(_this);
    return _this;
  }

  _createClass(UserList, [{
    key: 'pick',
    value: function pick(user) {
      // bubble this up..
      console.log(user);
      console.log(this);
      this.props.updateUser(user);
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(userid) {
      var users = this.state.data.filter(function (data) {
        return data.id !== userid;
      });
      this.setState({
        data: users
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      console.log(this.state.data);
      var items = this.state.data.map(function (user, i) {
        return _react2.default.createElement(UserItem, { key: user.id,
          user: user,
          activeUser: _this2.props.user,
          onClick: function onClick(user) {
            return _this2.pick(user);
          },
          onDelete: function onDelete(userid) {
            return _this2.handleDelete(userid);
          } });
      });
      return _react2.default.createElement(
        'div',
        null,
        items
      );
    }
  }]);

  return UserList;
}(_react2.default.Component);

exports.default = UserList;

var UserItem = function (_React$Component2) {
  _inherits(UserItem, _React$Component2);

  function UserItem() {
    _classCallCheck(this, UserItem);

    var _this3 = _possibleConstructorReturn(this, (UserItem.__proto__ || Object.getPrototypeOf(UserItem)).call(this));

    _this3.remove = _this3.remove.bind(_this3);
    return _this3;
  }

  _createClass(UserItem, [{
    key: 'remove',
    value: function remove(e) {
      var _this4 = this;

      e.stopPropagation();
      var userid = this.props.user.id;
      var usersService = _client2.default.service('users');
      var params = { query: { token: _client2.default.get('token') } };
      usersService.remove(userid, params).then(function (result) {
        _this4.props.onDelete(userid);
      }).catch(function (error) {
        console.error(error);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var user = this.props.user;
      // const canEdit = this.props.user.userid === this.props.currentUser.id ? 'canEdit' : ''
      var userClass = this.props.user.id == this.props.activeUser.id ? 'active' : '';
      var canEdit = 'canEdit';
      var date = parseDate(user.updatedAt);
      var time = parseTime(user.updatedAt);
      return _react2.default.createElement(
        'div',
        { className: 'user row ' + canEdit, onClick: function onClick() {
            return _this5.props.onClick(_this5.props.user);
          } },
        _react2.default.createElement(
          'div',
          { className: 'email ' + userClass },
          user.email
        ),
        _react2.default.createElement(
          'div',
          { className: 'calories' },
          user.goal,
          ' cal'
        ),
        _react2.default.createElement(
          'div',
          { className: 'role ' + user.role },
          user.role
        ),
        _react2.default.createElement(
          'div',
          { className: 'date' },
          date
        ),
        _react2.default.createElement(
          'div',
          { className: 'time' },
          time
        ),
        _react2.default.createElement(
          'div',
          { className: 'remove', onClick: this.remove },
          'x'
        )
      );
    }
  }]);

  return UserItem;
}(_react2.default.Component);

function parseDate(d) {
  return new Date(d).toISOString().substr(0, 10);
}

function parseTime(d) {
  return new Date(d).toISOString().substr(11, 5);
}


//////////////////
// WEBPACK FOOTER
// ./client/components/UserList.jsx
// module id = 221
// module chunks = 0